<template>
  <div id="box">
    <pc v-if="screenWidth > 1366" />
    <mobile v-else />
  </div>
</template>

<script>
import elementResizeDetector from 'element-resize-detector'
import Pc from '@/views/home/pc/index'
import Mobile from '@/views/home/mobile/index'
export default {
  name: 'HomeIndex',
  components: {
    Pc,
    Mobile
  },
  data() {
    return {
      screenWidth: '',
      screenHeight: ''
    }
  },
  mounted() {
    const that = this
    const erd = elementResizeDetector()
    erd.listenTo(document.getElementById('box'), (element) => {
      that.screenWidth = element.offsetWidth
      that.screenHeight = element.offsetHeight
    })
  }
}
</script>
